module.exports = __webpack_public_path__ + "img/logo.210d1892.png";